import { gql } from '@apollo/client';
import { Fragments } from 'api/fragments';

export const UPDATE_LAB = gql`
  mutation updateLab($name: String, $enable: Boolean!) {
    toggleLab(name: $name, enable: $enable) {
      id
      name
      enabled
      required
    }
  }
`;

export const LAB_LIST = gql`
  query labList {
    labs {
      ...Lab
    }
  }
  ${Fragments.Lab}
`;
